import {ZodError} from 'zod';

import {DEFAULT_GET_ERROR} from '../utils/errors';

export function extractErrorMessage(e: unknown): string {
  if (!(e instanceof Error)) {
    return '';
  } else if (e instanceof ZodError || e.name === 'ZodError') {
    return DEFAULT_GET_ERROR;
  } else {
    return e.message;
  }
}
